import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface CustomPreSelectAttributeState {
    categoryId?: string;
    isPreselectDataLoaded?: boolean;
}
const initialState: CustomPreSelectAttributeState = {};

const reducer = createTypedReducerWithImmer(initialState, {
    "Custom/PreSelectAttributes/SetData": (
        draft: Draft<CustomPreSelectAttributeState>,
        action: { payload: CustomPreSelectAttributeState },
    ) => {
        draft.isPreselectDataLoaded = action.payload.isPreselectDataLoaded;
        draft.categoryId = action.payload.categoryId;
    },
});

(reducers as any).customPreselectAttributeReducer = reducer;

export type PreSelectAttributeState = {
    customPreselectAttributeReducer: CustomPreSelectAttributeState;
} & ApplicationState;

type Reducers = {
    customPreselectAttributeReducer: typeof reducer;
};

export type CustomReducerActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
